import React from "react";
import { PaginatedContent } from "web/react/components/paginated-content/paginated-content";
import { TheEditHeader } from "web/react/components/the-edit-header";
import { TheEditStoryCard } from "web/react/emo/the-edit-story-card";
import analytics from "web/script/analytics/analytics";
import { TheEditSerializer } from "web/types/serializers";
import * as styles from "./the-edit.css";

function onLoadMore(): void {
    analytics.event(
        "the_edit_show_more",
        "click_show_more_button",
        "click",
        false,
        {},
        "",
        {},
        [],
        false,
        false
    );
}

export function TheEdit({ items, meta }: TheEditSerializer): React.ReactElement {
    return (
        <PaginatedContent
            items={items}
            meta={meta}
            rothkoModule="modules/the_edit/the_edit"
            onLoadMore={onLoadMore}
            backgroundColor="neutral1"
        >
            {(items) => (
                <div className={styles.container}>
                    <TheEditHeader />
                    <div className={styles.grid}>
                        {items.map((storyCardProps, i) => (
                            <TheEditStoryCard
                                key={`${storyCardProps.image_url}-${i}`}
                                index={i}
                                {...storyCardProps}
                            />
                        ))}
                    </div>
                </div>
            )}
        </PaginatedContent>
    );
}
